import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Popover } from "@msuite/ui/popover";
import { Tooltip } from "@msuite/ui/tooltip";
import type { Nullable, Tables } from "@msuite/utils/types";
import { ProjectPopover } from "@/components/popovers/project-popover";

/** Props Interface */
interface RelatedProjectIndicatorProps {
	relatedProjectId?: Nullable<string>;
	relatedProject?: Nullable<Tables<"projects">>;
}

export function RelatedProjectIndicator({
	relatedProject,
	relatedProjectId,
}: RelatedProjectIndicatorProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!relatedProjectId) return null;
	if (!relatedProject) return null;
	if (Array.isArray(relatedProject) && relatedProject.length === 0) return null;

	/** Render */
	return (
		<Popover
			variant="plain"
			trigger="hover"
			render={() => (
				<div className="w-[600px]">
					<ProjectPopover projectId={relatedProjectId} />
				</div>
			)}
		>
			<Tooltip label={t("projects.fields.related_project")}>
				<Icon
					name="Link"
					className="text-primaryGray-500"
				/>
			</Tooltip>
		</Popover>
	);
}
